const defaultConfig = {
    product: 'rovo',
    experienceId: 'ai-mate',
    assistanceServiceConfig: {
        headers: {
            'x-issynthetic-traffic': 'false',
        },
        baseUrl: 'https://support.stg.internal.atlassian.com/gateway/api/assist',
        credentials: 'include' as RequestCredentials,
    },
};

export const createAssistantConfig = (siteId: string, widgetId: string, jiraDisplayUrl: string) => {
    return {
        ...defaultConfig,
        siteId,
        widgetId,
        assistanceServiceConfig: {
            ...defaultConfig.assistanceServiceConfig,
            baseUrl: `${jiraDisplayUrl}/gateway/api/assist`,
            headers: {
                ...defaultConfig.assistanceServiceConfig.headers,
                'X-Cloudid': siteId,
            },
        },
    };
};
